export default __webpack_public_path__ + "static/media/NFT.d55d1af5.svg";